import type { UerActKc2Query } from '@gql/graphql';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { gqlGetActKC2 } from '../workOrderQueries';

export const useGetActKc2 = (actKC2Id?: number) => {
    const variables = useMemo(() => (actKC2Id ? { actKC2Id } : undefined), [actKC2Id]);

    const requestId = useMemo(() => `getActKC2${actKC2Id || ''}`, [actKC2Id]);

    const [getActKC2Response, getActKC2Status] = useRequest<UerActKc2Query, { actKC2Id: number }>({
        requestId,
        query: gqlGetActKC2,
        variables,
        withEffect: !!variables,
    });

    const [getActKC2Reset] = useResetStoreData({ requestId });

    return {
        getActKC2Response,
        getActKC2Status,
        getActKC2Reset,
    };
};
